import { useTheme } from "@/src/styles/theme-provider";
import { ArrowDown2 } from "iconsax-react-nativejs";
import React, { useState } from "react";
import { Pressable, Text, View } from "react-native";

type AccordionType = Readonly<{
  title: string;
  rightAction?: React.ReactNode;
  children: React.ReactNode;
  defaultOpen: boolean;
}>;

const ScAccordion = ({
  title,
  rightAction,
  children,
  defaultOpen = false,
}: AccordionType) => {
  const [open, setOpen] = useState(defaultOpen);
  const { themeVars } = useTheme();

  return (
    <View className="bg-ash rounded-[12px] md:border md:border-ash-3">
      <Pressable
        onPress={() => setOpen(!open)}
        className="flex-row items-center justify-between px-4 py-3 flex-wrap gap-2 hover:bg-ash-3 hover:rounded-lg"
      >
        <View className="flex-row items-center gap-2">
          <ArrowDown2
            size={18}
            color={themeVars["--color-ash-2"] as string}
            className={`${open ? "rotate-180" : ""}`}
          />
          <Text className="text-onyx text-sm font-medium">{title}</Text>
        </View>

        {rightAction}
      </Pressable>

      {open && <View className="px-4 pb-4 gap-3">{children}</View>}
    </View>
  );
};

export default ScAccordion;
